import React, { Fragment, useState, useEffect } from 'react';
import { string, shape } from 'prop-types';
import RadioGroup from './RadioGroup';

import Dialog from '../components/Dialog';
import RichContent from '../components/RichContent';

import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from './colorList.module.css';
/**
 * ProductConfigurator
 *
 * @typedef ProductConfigurator
 * @kind functional component
 *
 * @param {props} props React component props
 *
 * @returns {React.Element} A React component that displays a configurator
 */
const CaseTypes = props => {
    const {
        items,
        models = [],
        selectedModel,
        selectedType,
        onCaseModelChange,
        onCaseTypeChange,
        info,
        sectionDisabled
    } = props;

    //    if (!items.length) {
    //        return null;
    //    }

    const classes = useStyle(defaultClasses, props.classes);

    const [isInfoOpen, setIsInfoOpen] = useState(false);

    const showInfo = e => {
        e.preventDefault && e.preventDefault();
        setIsInfoOpen(true);
    };

    const hideInfo = e => {
        e.preventDefault && e.preventDefault();
        setIsInfoOpen(false);
    };

    return (
        <fieldset className={classes.section} disabled={sectionDisabled}>
            <legend>
                {_('Tipo de cajón')}{' '}
                {info && (
                    <span
                        onClick={showInfo}
                        className={classes.info}
                        title={_('Instrucciones sobre el cajón')}
                    >
                        👁 {_('Read')} {_('Instrucciones sobre el cajón')}
                    </span>
                )}
            </legend>
            {models && models.length ? (
                <Fragment>
                    SELECTEER KASTHOOGTE
                    <div className={classes.caseresults}>
                        <RadioGroup
                            items={models}
                            field="caseModel"
                            initialValue={selectedModel}
                            radioGroupName="caseModel"
                            onValueChange={onCaseModelChange}
                        />
                    </div>
                </Fragment>
            ) : null}
            <div className="subtitle">{_('Select your case')}</div>
            <div className={classes.caseresults}>
                <RadioGroup
                    items={items}
                    field="kast"
                    initialValue={selectedType}
                    radioGroupName="case"
                    onValueChange={onCaseTypeChange}
                />
            </div>
            {info ? (
                <Dialog
                    isOpen={isInfoOpen}
                    onConfirm={hideInfo}
                    onCancel={hideInfo}
                    showCancelButton={false}
                    confirmText={_('Close')}
                    title={info.title}
                >
                    <RichContent html={info.text} />
                </Dialog>
            ) : null}
        </fieldset>
    );
};
/*
ProductConfigurator.propTypes = {
    clases: shape({
        root: string,
        icon: string
    }),
    title: string,
    text: string,
    buttonTitle: string,
    buttonText: string
};

ProductConfigurator.defaultProps = {
    buttonTitle: _('Share this element'),
    buttonText: _('Share this!'),
};
*/
export default CaseTypes;
